var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCautionGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2322 5.99991L45.2842 38.9999C45.4597 39.3039 45.5521 39.6488 45.5521 39.9999C45.5521 40.351 45.4597 40.6959 45.2842 40.9999C45.1087 41.3039 44.8562 41.5564 44.5522 41.7319C44.2481 41.9075 43.9033 41.9999 43.5522 41.9999H5.44819C5.09712 41.9999 4.75224 41.9075 4.44821 41.7319C4.14418 41.5564 3.89171 41.3039 3.71618 40.9999C3.54065 40.6959 3.44824 40.351 3.44824 39.9999C3.44824 39.6488 3.54066 39.3039 3.71619 38.9999L22.7682 5.99991C22.9437 5.6959 23.1962 5.44344 23.5002 5.26792C23.8043 5.0924 24.1491 5 24.5002 5C24.8512 5 25.1961 5.0924 25.5001 5.26792C25.8042 5.44344 26.0567 5.6959 26.2322 5.99991ZM22.5002 31.9999V35.9999H26.5002V31.9999H22.5002ZM22.5002 17.9999V27.9999H26.5002V17.9999H22.5002Z",
    fill: "#D4D3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionGrey);
export default __webpack_public_path__ + "static/media/caution_grey.026f5e31bfa93f41af1dfc84a939b5d8.svg";
export { ForwardRef as ReactComponent };